import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de création d'un marchand (`POST /Merchants/add`).
 *
 * Factory (règle projet) : créé via `createMerchantSchema()` et mémoïsé au
 * niveau composant sur la langue courante — jamais d'instance exportée.
 */
export const createMerchantSchema = () =>
  z.object({
    ownerPartyId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    legalName: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    tradeName: z.string().trim().or(z.literal("")).optional(),
    categoryCode: z.string().trim().or(z.literal("")).optional(),
  });

export type MerchantFormValues = z.infer<ReturnType<typeof createMerchantSchema>>;

/** Schéma du formulaire de création d'un sous-marchand (identique à `add`). */
export const createSubMerchantSchema = createMerchantSchema;
export type SubMerchantFormValues = MerchantFormValues;
